var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},_vm._l((_vm.items),function(item){return _c('div',{key:item.id},[_c('img',{attrs:{"src":_vm.imgpath(item),"alt":""}}),_vm._v(" "),_c('a',{attrs:{"href":item.pageurl,"target":"_blank"}},[_c('h1',{},[_vm._v("  "+_vm._s(item.title))]),_vm._v(" "),_c('h2',{},[_vm._v("  "+_vm._s(item.author))])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ba0303e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 